export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-credit-card-00b2fca7223e21254703f2ae5883c8c0.svg";